import { Component, OnInit, Inject, ChangeDetectionStrategy} from '@angular/core';
import { ISchedule, IScheduledDropdownList,IScheduledDropdown, IChangeOwner } from '../scheduled/scheduled.model';
import { ScheduledService } from '../scheduled/scheduled.service';
import { AppService } from '@irb/app.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IrbAppEvents } from '@irb/app.events';

@Component({ standalone: false,
  selector: 'irb-owner-scheduled-dialog',
  templateUrl: './owner-scheduled-dialog.component.html',
  styleUrls: ['./owner-scheduled-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class OwnerScheduledDialogComponent implements OnInit {

  scheduledRebalances: Array<ISchedule>;
  ownerList:any;
  owner:IScheduledDropdown;
  ownerRequestObj = {} as IChangeOwner;
  refreshGridFunction: Function;
  isDisable:boolean = true;

  constructor(public dialogRef: MatDialogRef<OwnerScheduledDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public mdd: any,
    private as: AppService,
    private readonly scheduledService: ScheduledService) {

  }

  ngOnInit(): void {
    if(this.mdd.scheduledRebalances !== undefined){
        this.scheduledRebalances = this.mdd.scheduledRebalances.selectedIds as Array<ISchedule>;
        this.ownerList = this.mdd.scheduledRebalances.data;
        this.getSelectedSchdRebalancesIds();
      }
        this.refreshGridFunction = this.mdd.refreshGridFunction || null;
  } 
 
  close() {   
    if(this.dialogRef.close !== undefined)
        this.dialogRef.close();
    }  

  getSelectedSchdRebalancesIds() {
    let analysisIds: Array<string> = [];
    let versionIds: Array<string> = [];
    this.scheduledRebalances.forEach(function(item){ 
     analysisIds.push(item.analysisId.toString());
     versionIds.push(item.versionId.toString());  
     });
     this.ownerRequestObj.analysisIds = analysisIds ;
     this.ownerRequestObj.versionIds = versionIds;
   }
   
 
  changeOwnerSchdReblances() {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.scheduledService.changeOwnerSchdRebalance(this.ownerRequestObj).subscribe((data) => {
    if(data.responseStatus === "SUCCESS"){
      if(this.refreshGridFunction !== undefined){
       this.refreshGridFunction();
      }
       this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
       this.close();
       this.as.fireEvent(IrbAppEvents.SHOW_TOAST, { severity: 'success', summary: 'Success', detail: 'Your change has been saved' });
    } else{
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
      severity: 'error',
      summary: 'Please refresh Page',
      detail: 'Exception occurred'
     });
    }
   }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
   });
  }

  onChange(param:any){
    if(param.name != null){
      this.ownerRequestObj.userId = param.name;
      this.isDisable = false;
    }
  }
}
